import canvas from '@helpers/canvas.js';
import { router } from '@routes/routes';
import { store } from '@stores/store';
import { createApp } from 'vue';
import '@styles/index.css';
import App from './App.vue';

const app = createApp(App).use(router).use(store);

// TODO: Remove global properties
// Mount canvas functions to be available globally
app.config.globalProperties.$c = canvas;
app.mount('#app');
